import util from './util';

export default (config, slot, slotBidderCfg) => {
	const {
		targetingFields = [],
		...params
	} = util.getParamsFromConfig(config, slotBidderCfg);

	params.keywords = util.getTargeting(slot, targetingFields);

	return {
		'bidder': slotBidderCfg.bidder || 'appnexus',
		params
	};
};
